<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>

              <div class="flex justify-center">
                <img
                  v-if="selectedFileUrl || store.sectorForm.imageName"
                  :src="selectedFileUrl ?? fileUrl + store.sectorForm.imageName"
                  alt="Foto do setor"
                  class="mt-10 mb-auto rounded-md w-60 max-h-60 hidden md:block"
                />
              </div>

            </div>

            <div id="form-fields" class="lg:col-span-2">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                <!-- sector name -->
                <div class="md:col-span-3">
                  <BaseInput
                    type="text"
                    name="sectorForm.name"
                    v-model="store.sectorForm.name"
                    :info="'Nome do setor'"
                    label="Informe o nome deste setor"
                    :required-field="true"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton @click="store.sectorForm.name = undefined" />
                    </template>
                  </BaseInput>

                  <span name="sectorForm.name" class="text-red-600 text-sm" />
                </div>

                <!-- sector cod -->
                <div class="md:col-span-2">
                  <BaseInput
                    type="text"
                    name="sectorForm.cod"
                    v-model="store.sectorForm.cod"
                    :info="'Código do setor'"
                    label="Código do setor"
                    :required-field="false"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton @click="store.sectorForm.cod = undefined" />
                    </template>
                  </BaseInput>
                </div>

                <!-- sector category -->
                <div class="md:col-span-3">
                  <BaseInput
                    type="text"
                    name="sectorForm.category"
                    v-model="store.sectorForm.category"
                    :info="'Categoria do setor'"
                    label="Categoria"
                    :required-field="false"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton @click="store.sectorForm.category = undefined" />
                    </template>
                  </BaseInput>

                  <span name="sectorForm.category" class="text-red-600 text-sm" />
                </div>
                
                <!-- sector number -->
                <div class="md:col-span-2">
                  <BaseInput
                    type="text"
                    name="sectorForm.number"
                    v-model="store.sectorForm.number"
                    :info="'Número do setor'"
                    label="Número"
                    :required-field="false"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton @click="store.sectorForm.number = undefined" />
                    </template>
                  </BaseInput>
                </div>

                <!-- sector description -->
                <div class="md:col-span-3">
                  <BaseInput
                    type="text"
                    name="sectorForm.category"
                    v-model="store.sectorForm.description"
                    :info="'Descrição / observação'"  
                    label="Descrição / observação"
                    :required-field="false"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton @click="store.sectorForm.description = undefined" />
                    </template>
                  </BaseInput>
                </div>
                
                <!-- sector priority -->
                <div class="md:col-span-2">
                  <div class="md:col-span-2 mt-1.5">
                    <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
                      Prioridade <a class="text-red-600 ml-1">*</a>
                    </label>
                    <div
                      class="h-10 flex rounded items-center"
                    >
                      <SimpleSelect
                        class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                        :data="sectorPriority"
                        :initialValue="store.sectorForm.priority"
                        @selected-data="(val) => (store.sectorForm.priority = val)"
                      />
                    </div>
                  </div>

                  <span
                    name="sectorForm.priority"
                    class="text-red-600 text-sm"
                  />
                </div>

                <!-- fluxo da imagem -->
                <div class="flex justify-center">
                  <img
                    v-if="selectedFileUrl || store.sectorForm.imageName"
                    :src="selectedFileUrl ?? fileUrl + store.sectorForm.imageName"
                    alt="Foto do setor"
                    class="mt-2 rounded-md w-60 max-h-60 block md:hidden"
                  />
                </div>

                <div class="md:col-span-5 mt-2 flex h-10">
                  <label
                    class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                  >
                    <!-- <i class="fa-solid fa-helmet-safety"></i> -->

                    <div class="flex mt-auto mb-auto h-full">
                      <div class="w-full mt-auto mb-auto flex justify-center">
                        <component 
                          :is="selectedFileName ? image : fileImage"
                          class="w-5 h-5 mr-1" 
                          :class="[
                            selectedFileName ? 'text-green-500' : 'text-gray-500'
                          ]"
                        />
    
                        Foto
                      </div>
                    </div>
                    <input
                      type="file"
                      class="hidden"
                      @change="handleFileChange"
                    />
                  </label>
                  <input
                    type="text"
                    style="padding-left: 10px !important"
                    class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                    :value="selectedFileName"
                  />
                  
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-center mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../utils/CleanInputButton.vue';
import BaseInput from '@/components/Inputs/BaseInput.vue';
import { dataExtinguisher } from '../store'
import { sectorPriority } from '../lookups/form';
import { 
  PhFileImage,
  PhImage
} from '@phosphor-icons/vue';
import { showToast as toast } from '@/helpers/UseToasts'
import { markRaw } from 'vue';

export default({
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
  },
  props: {
    descriptionTitle: String,
  },
  data () {
    const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
    const fileImage = markRaw(PhFileImage)
    const image = markRaw(PhImage)

    return {
      fileImage,
      image,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataExtinguisher.state,
      dataExtinguisher,
      sectorPriority,
      fileUrl,
      toast,
      markRaw
    }
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (allowedExtensions.includes(fileExtension)) {
          this.selectedFileName = file.name
          this.selectedFileUrl = URL.createObjectURL(file)
          
          this.store.sectorForm.imageName = this.selectedFileName
          this.store.sectorForm.image = file
        } else 
          return this.toast(
            'Protege informa: ',
            'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas',
            'info'
          )
        
      }
    }
  }
})
</script>
